import { Injectable, Output, EventEmitter, Directive } from '@angular/core';

@Directive()
@Injectable({
    providedIn: 'root'
  })
export class CalculatorServices {
    isOpen: boolean;

    @Output() change: EventEmitter<boolean> = new EventEmitter();
    @Output() close: EventEmitter<boolean> = new EventEmitter();
    toggle(){
        this.isOpen = true;
        this.change.emit(this.isOpen);
    }
}